import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'footer-copyright',
  templateUrl: './footer-copyright.component.html',
  styleUrls: ['./footer-copyright.component.scss']
})
export class FooterCopyrightComponent implements OnInit {

  @Input() options = { page: 'default' };
  currentDate: Date = new Date();

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/footer-copyright/footer-copyright.component.ts